import React, { useCallback, useEffect, useRef, useState } from "react";
import API from "../../api";
import { uniqueId } from "lodash";
import Calendar from "react-calendar";

// redux
import { mapDispatchProps, mapStateToProps } from "../../store/store";
import { connect } from "react-redux";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
} from "chart.js";

import Zoom from "chartjs-plugin-zoom";
import { Bar } from "react-chartjs-2";
import { useForceUpdate } from "../../hooks/useForceUpdate";
import { isEmpty } from "../../helpers/object";
import Label from "../../components/label";
import dayjs from "../../plugins/dayjs";
import { useLanguage } from '@languages/index';

ChartJS.register(
  Zoom,
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const ModelActivityApprovedAtIndex = (props: any) => {
  const language = useLanguage();   
  const languageTexts = { ...language.common, ...language.pages.charts };

  const [selectedDuration, setSelectedDuration] = useState({
    startsAt: `${dayjs()
      .subtract(2, "week")
      .startOf("week")
      .format("YYYY-MM-DD")}`,

    endsAt: `${dayjs().subtract(2, "week").endOf("week").format("YYYY-MM-DD")}`,
  });

  const forceUpdate = useForceUpdate();

  const options = {
    responsive: true,
    maintainAspectRatio: false,

    scales: {
      y: {
        beginAtZero: true,
      },
    },

    plugins: {
      legend: {
        display: false,
        labels: {
          usePointStyle: true,
        },
      },
      title: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";

            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += languageTexts._num_of_person(context.parsed.y);
            }
            return label;
          },
        },
      },
      zoom: {
        zoom: {
          wheel: {
            enabled: true,
          },
          pinch: {
            enabled: true,
          },
          mode: "x" as "x",
        },
        pan: {
          enabled: true,
          mode: "x" as "x",
        },
      },
    },

    onClick: function (evt, element) {
      if (element.length > 0) {
        const index = element[0].index;
        const value = element[0].element.$context.raw;
      }
    },
  };

  const CartRetentionChart = (props: any) => {
    if (!selectedDuration) {
      return (
        <div className="flex flex-row justify-center">
          <span className="text-2xl font-bold mx-auto">
            {languageTexts.approved_at_text_1}
          </span>
        </div>
      );
    }

    const [chartData, setChartData] = useState<any>();
    const labels = useRef<Array<any>>();
    const usersFound = useRef<Array<any>>();
    const usersNotFound = useRef<Array<any>>();
    const usersTotal = useRef<number>();
    const users = useRef<number>();
    const weeks = useRef<number>();

    useEffect(() => {
      API.Chart.index({
        chart: "MODELS-CART-APPROVED-AT",
        ...selectedDuration,
      })
        .then((response) => {
          const values = response.data.chart;

          usersFound.current = response.data.usersFound;
          usersNotFound.current = response.data.usersNotFound;
          usersTotal.current = response.data.usersTotal;
          labels.current = response.data.labels;
          users.current = response.data.users;
          weeks.current = response.data.weeks;

          let chart = {
            data: values,
            borderColor: "rgb(255, 188, 100)",
            borderWidth: 0,
            backgroundColor: "rgb(255, 188, 100)",
            pointStyle: "circle",
            pointRadius: 4,
            pointBorderColor: "rgb(0, 0, 0)",
          };

          setChartData({
            labels: response.data.labels,
            tension: 0.5,
            datasets: [chart],
          });
        })
        .catch((error) => {
          props.showModal({ text: error.message });
        });
    }, []);

    const render = () => {
      return !labels.current ? (
        <div className="flex flex-row mx-10 my-10 justify-center items-center">
          <div className="flex flex-row justify-center text-center my-5">
            <span className="prose prose-xl text-slate-400">
              {languageTexts.loading_1}
            </span>
          </div>
        </div>
      ) : (
        <div className="px-5 md:w-[800px] xl:w-[1024px] mx-auto">
          <div className="flex flex-row px-5">
            <div className="flex flex-col mb-4">
              <span className="text-xl font-bold tracking-tighter">
                {languageTexts.approved_at_text_2}
              </span>
              <span className="text-sm tracking-tighter text-gray-400">
                {languageTexts._approved_at_text_3(users.current)}
              </span>
            </div>
          </div>

          <span className="px-5 text-md tracking-tighter font-bold">
            {languageTexts._approved_at_text_4(weeks.current)}
          </span>

          <div className="flex flex-row px-5 gap-3 mb-10">
            {chartData && !isEmpty(usersFound.current)
              ? Object.values(usersFound.current).map((weeks, index) => {
                  return (
                    <div
                      key={`foundUsers${uniqueId()}`}
                      className="flex flex-col gap-1"
                    >
                      <div className="flex flex-col">
                        <span className="text-sm tracking-tighter text-gray-400">
                          {parseInt(Object.keys(usersFound.current)[index]) > 0
                            ? languageTexts._weeks_ago(Object.keys(usersFound.current)[index])
                            : languageTexts.this_week}
                        </span>
                        <span className="text-sm tracking-tighter text-gray-400">
                          {languageTexts._num_of_person(weeks)}
                        </span>
                      </div>
                      <Label
                        text={
                          Object.values(usersFound.current).length - 1 == index
                            ? "100.00%"
                            : `${(
                                (Object.values(usersFound.current)
                                  .filter((arr, arrIndex) => arrIndex <= index)
                                  .reduce(function add(sum, currValue) {
                                    return sum + currValue;
                                  }, 0) /
                                  users.current) *
                                100
                              ).toFixed(2)}%`
                        }
                      />
                    </div>
                  );
                })
              : null}
          </div>

          {/* <span className="px-5 text-md tracking-tighter font-bold">
            {`해당 기간 가입한 회원중 장바구니에 상품을 담지 않은 회원 수 (최대 ${weeks.current}주)`}
          </span>

          <div className="flex flex-row px-5 gap-3 mb-10">
            {chartData && !isEmpty(usersNotFound.current)
              ? Object.values(usersNotFound.current).map((weeks, index) => {
                  return (
                    <div
                      key={`foundUsers${uniqueId()}`}
                      className="flex flex-col gap-1"
                    >
                      <div className="flex flex-col">
                        <span className="text-sm tracking-tighter text-gray-400">
                          {parseInt(Object.keys(usersNotFound.current)[index]) >
                          0
                            ? `${
                                Object.keys(usersNotFound.current)[index]
                              }주 전`
                            : `이번 주`}
                        </span>
                        <span className="text-sm tracking-tighter text-gray-400">
                          {weeks}명
                        </span>
                      </div>
                      <Label
                        text={`${((weeks / usersTotal.current) * 100).toFixed(
                          2,
                        )}%`}
                      />
                    </div>
                  )
                })
              : null}
          </div> */}

          <div className="flex flex-row">
            {chartData ? <Bar options={options} data={chartData} /> : null}
          </div>
        </div>
      );
    };

    return render();
  };

  const RentalRetentionChart = (props: any) => {
    if (!selectedDuration) {
      return (
        <div className="flex flex-row justify-center">
          <span className="text-2xl font-bold mx-auto">
            {languageTexts.approved_at_text_1}
          </span>
        </div>
      );
    }

    const [chartData, setChartData] = useState<any>();
    const labels = useRef<Array<any>>();
    const usersFound = useRef<Array<any>>();
    const usersNotFound = useRef<Array<any>>();
    const usersTotal = useRef<number>();
    const users = useRef<number>();
    const weeks = useRef<number>();

    useEffect(() => {
      API.Chart.index({
        chart: "MODELS-RENTAL-APPROVED-AT",
        ...selectedDuration,
      })
        .then((response) => {
          const values = response.data.chart;

          usersFound.current = response.data.usersFound;
          usersNotFound.current = response.data.usersNotFound;
          usersTotal.current = response.data.usersTotal;
          labels.current = response.data.labels;
          users.current = response.data.users;
          weeks.current = response.data.weeks;

          let chart = {
            data: values,
            borderColor: "rgb(255, 188, 100)",
            borderWidth: 0,
            backgroundColor: "rgb(255, 188, 100)",
            pointStyle: "circle",
            pointRadius: 4,
            pointBorderColor: "rgb(0, 0, 0)",
          };

          setChartData({
            labels: response.data.labels,
            tension: 0.5,
            datasets: [chart],
          });
        })
        .catch((error) => {
          props.showModal({ text: error.message });
        });
    }, []);

    const render = () => {
      return !labels.current ? (
        <div className="flex flex-row mx-10 my-10 justify-center items-center">
          <div className="flex flex-row justify-center text-center my-5">
            <span className="prose prose-xl text-slate-400">
              {languageTexts.loading_1}
            </span>
          </div>
        </div>
      ) : (
        <div className="px-5 md:w-[800px] xl:w-[1024px] mx-auto">
          <div className="flex flex-row px-5">
            <div className="flex flex-col mb-4">
              <span className="text-xl font-bold tracking-tighter">
                {languageTexts.approved_at_text_5}
              </span>
              <span className="text-sm tracking-tighter text-gray-400">
                {languageTexts._approved_at_text_6(users.current)}
              </span>
            </div>
          </div>

          <span className="px-5 text-md tracking-tighter font-bold">
            {languageTexts._approved_at_text_7(weeks.current)}
          </span>

          <div className="flex flex-row px-5 gap-3 mb-10">
            {chartData && !isEmpty(usersFound.current)
              ? Object.values(usersFound.current).map((weeks, index) => {
                  return (
                    <div
                      key={`foundUsers${uniqueId()}`}
                      className="flex flex-col gap-1"
                    >
                      <div className="flex flex-col">
                        <span className="text-sm tracking-tighter text-gray-400">
                          {parseInt(Object.keys(usersFound.current)[index]) > 0
                            ? languageTexts._weeks_ago(Object.keys(usersFound.current)[index])
                            : languageTexts.this_week}
                        </span>
                        <span className="text-sm tracking-tighter text-gray-400">
                          {languageTexts._num_of_person(weeks)}
                        </span>
                      </div>
                      <Label
                        text={
                          Object.values(usersFound.current).length - 1 == index
                            ? "100.00%"
                            : `${(
                                (Object.values(usersFound.current)
                                  .filter((arr, arrIndex) => arrIndex <= index)
                                  .reduce(function add(sum, currValue) {
                                    return sum + currValue;
                                  }, 0) /
                                  users.current) *
                                100
                              ).toFixed(2)}%`
                        }
                      />
                    </div>
                  );
                })
              : null}
          </div>

          {/* <span className="px-5 text-md tracking-tighter font-bold">
            {`해당 기간 가입한 회원 중 대여 신청하지 않은 회원 수 (최대 ${weeks.current}주)`}
          </span>

          <div className="flex flex-row px-5 gap-3 mb-10">
            {chartData && !isEmpty(usersNotFound.current)
              ? Object.values(usersNotFound.current).map((weeks, index) => {
                  return (
                    <div
                      key={`foundUsers${uniqueId()}`}
                      className="flex flex-col gap-1"
                    >
                      <div className="flex flex-col">
                        <span className="text-sm tracking-tighter text-gray-400">
                          {parseInt(Object.keys(usersNotFound.current)[index]) >
                          0
                            ? `${
                                Object.keys(usersNotFound.current)[index]
                              }주 전`
                            : `이번 주`}
                        </span>
                        <span className="text-sm tracking-tighter text-gray-400">
                          {weeks}명
                        </span>
                      </div>
                      <Label
                        text={`${((weeks / usersTotal.current) * 100).toFixed(
                          2,
                        )}%`}
                      />
                    </div>
                  )
                })
              : null}
          </div> */}

          <div className="flex flex-row">
            {chartData ? <Bar options={options} data={chartData} /> : null}
          </div>
        </div>
      );
    };

    return render();
  };

  const RentalMasterRetentionChart = (props: any) => {
    if (!selectedDuration) {
      return (
        <div className="flex flex-row justify-center">
          <span className="text-2xl font-bold mx-auto">
            {languageTexts.approved_at_text_1}
          </span>
        </div>
      );
    }

    const [chartData, setChartData] = useState<any>();
    const labels = useRef<Array<any>>();
    const usersFound = useRef<Array<any>>();
    const usersNotFound = useRef<Array<any>>();
    const usersTotal = useRef<number>();
    const users = useRef<number>();
    const weeks = useRef<number>();

    useEffect(() => {
      API.Chart.index({
        chart: "MODELS-RENTAL-MASTER-APPROVED-AT",
        ...selectedDuration,
      })
        .then((response) => {
          const values = response.data.chart;

          usersFound.current = response.data.usersFound;
          usersNotFound.current = response.data.usersNotFound;
          usersTotal.current = response.data.usersTotal;
          labels.current = response.data.labels;
          users.current = response.data.users;
          weeks.current = response.data.weeks;

          let chart = {
            data: values,
            borderColor: "rgb(255, 188, 100)",
            borderWidth: 0,
            backgroundColor: "rgb(255, 188, 100)",
            pointStyle: "circle",
            pointRadius: 4,
            pointBorderColor: "rgb(0, 0, 0)",
          };

          setChartData({
            labels: response.data.labels,
            tension: 0.5,
            datasets: [chart],
          });
        })
        .catch((error) => {
          props.showModal({ text: error.message });
        });
    }, []);

    const render = () => {
      return !labels.current ? (
        <div className="flex flex-row mx-10 my-10 justify-center items-center">
          <div className="flex flex-row justify-center text-center my-5">
            <span className="prose prose-xl text-slate-400">
              {languageTexts.loading_1}
            </span>
          </div>
        </div>
      ) : (
        <div className="px-5 md:w-[800px] xl:w-[1024px] mx-auto">
          <div className="flex flex-row px-5">
            <div className="flex flex-col mb-4">
              <span className="text-xl font-bold tracking-tighter">
                {languageTexts.approved_at_text_8}
              </span>
              <span className="text-sm tracking-tighter text-gray-400">
                {languageTexts._approved_at_text_3(users.current)}
              </span>
            </div>
          </div>

          <span className="px-5 text-md tracking-tighter font-bold">
            {languageTexts._approved_at_text_7(weeks.current)}
          </span>

          <div className="flex flex-row px-5 gap-3 mb-10">
            {chartData && !isEmpty(usersFound.current)
              ? Object.values(usersFound.current).map((weeks, index) => {
                  return (
                    <div
                      key={`foundUsers${uniqueId()}`}
                      className="flex flex-col gap-1"
                    >
                      <div className="flex flex-col">
                        <span className="text-sm tracking-tighter text-gray-400">
                          {parseInt(Object.keys(usersFound.current)[index]) > 0
                            ? languageTexts._weeks_ago(Object.keys(usersFound.current)[index])
                            : languageTexts.this_week}
                        </span>
                        <span className="text-sm tracking-tighter text-gray-400">
                          {languageTexts._num_of_person(weeks)}
                        </span>
                      </div>
                      <Label
                        text={
                          Object.values(usersFound.current).length - 1 == index
                            ? "100.00%"
                            : `${(
                                (Object.values(usersFound.current)
                                  .filter((arr, arrIndex) => arrIndex <= index)
                                  .reduce(function add(sum, currValue) {
                                    return sum + currValue;
                                  }, 0) /
                                  users.current) *
                                100
                              ).toFixed(2)}%`
                        }
                      />
                    </div>
                  );
                })
              : null}
          </div>

          {/* <span className="px-5 text-md tracking-tighter font-bold">
            {`해당 기간 가입한 회원중 대여 신청하지 않은 회원 수 (최대 ${weeks.current}주)`}
          </span>

          <div className="flex flex-row px-5 gap-3 mb-10">
            {chartData && !isEmpty(usersNotFound.current)
              ? Object.values(usersNotFound.current).map((weeks, index) => {
                  return (
                    <div
                      key={`foundUsers${uniqueId()}`}
                      className="flex flex-col gap-1"
                    >
                      <div className="flex flex-col">
                        <span className="text-sm tracking-tighter text-gray-400">
                          {parseInt(Object.keys(usersNotFound.current)[index]) >
                          0
                            ? `${
                                Object.keys(usersNotFound.current)[index]
                              }주 전`
                            : `이번 주`}
                        </span>
                        <span className="text-sm tracking-tighter text-gray-400">
                          {weeks}명
                        </span>
                      </div>
                      <Label
                        text={`${((weeks / usersTotal.current) * 100).toFixed(
                          2,
                        )}%`}
                      />
                    </div>
                  )
                })
              : null}
          </div> */}

          <div className="flex flex-row">
            {chartData ? <Bar options={options} data={chartData} /> : null}
          </div>
        </div>
      );
    };

    return render();
  };

  const ModelRentalStatistics = (props: any) => {
    const [statistics, setStatistics] = useState<any>();

    useEffect(() => {
      fetchStatistics();
    }, []);

    const fetchStatistics = () => {
      API.Chart.modelRentalStatistics({})
        .then((response) => {
          setStatistics(response.data);
        })
        .catch((error) => {});
    };

    const render = useCallback(() => {
      return statistics ? (
        <div className="flex flex-col gap-2">
          <div className="flex flex-row px-5">
            <div className="flex flex-col mb-4">
              <span className="text-xl font-bold tracking-tighter">
                {languageTexts.approved_at_text_9}
              </span>
              <span className="text-sm tracking-tighter text-gray-400">
                {languageTexts._num_of_person(statistics.models)}
              </span>
            </div>
          </div>

          <div className="flex flex-row px-5">
            <div className="flex flex-col mb-4">
              <span className="text-xl font-bold tracking-tighter">
                {languageTexts.approved_at_text_10}
              </span>
              <span className="text-sm tracking-tighter ">
                {languageTexts._num_of_person(statistics.activeUsersOneMonth)} (
                {(
                  (statistics.activeUsersOneMonth / statistics.models) *
                  100
                ).toFixed(2)}
                %)
              </span>
            </div>
          </div>

          <div className="flex flex-row px-5">
            <div className="flex flex-col mb-4">
              <span className="text-xl font-bold tracking-tighter">
                {languageTexts.approved_at_text_11}
              </span>
              <span className="text-sm tracking-tighter ">
                {languageTexts._num_of_person(statistics.activeUsersTwoMonth)} (
                {(
                  (statistics.activeUsersTwoMonth / statistics.models) *
                  100
                ).toFixed(2)}
                %)
              </span>
            </div>
          </div>

          <div className="flex flex-row px-5">
            <div className="flex flex-col mb-4">
              <span className="text-xl font-bold tracking-tighter">
                {languageTexts.approved_at_text_12}
              </span>
              <span className="text-sm tracking-tighter ">
                {languageTexts._num_of_person(statistics.activeUsersThreeMonth)} (
                {(
                  (statistics.activeUsersThreeMonth / statistics.models) *
                  100
                ).toFixed(2)}
                %)
              </span>
            </div>
          </div>
        </div>
      ) : null;
    }, [statistics]);

    return render();
  };

  const render = useCallback(() => {
    return (
      <div className="flex flex-col my-10 gap-10">
        <div className="px-5 md:w-[800px] xl:w-[1024px] mx-auto">
          <div className="flex flex-col my-5 px-5">
            <span className="text-3xl font-bold tracking-tighter text-center">
              {languageTexts._approved_at_text_13(selectedDuration.startsAt, selectedDuration.endsAt)}
            </span>
            <span className="text-3xl font-bold tracking-tighter text-center">
              {languageTexts.approved_at_text_14}
            </span>
          </div>
        </div>

        <div className="px-5 md:w-[800px] xl:w-[1024px] mx-auto">
          <div className="flex flex-col my-10 px-5 items-center">
            <span className="text-xl font-bold tracking-tighter mb-5">
              {languageTexts.approved_at_text_15}
            </span>

            <div className="flex flex-row justify-center min-w-[500px]">
              <Calendar
                calendarType="gregory"
                className="min-w-[500px]"
                showWeekNumbers={true}
                onChange={(value: any) => {
                  if (!value) {
                    return "";
                  }

                  const date = new Date(value);
                  const dateConverted = dayjs(date).format("YYYY-MM-DD");

                  setSelectedDuration({
                    startsAt: `${dayjs(date)
                      .subtract(2, "week")
                      .startOf("week")
                      .format("YYYY-MM-DD")}`,

                    endsAt: `${dayjs(date)
                      .subtract(2, "week")
                      .endOf("week")
                      .format("YYYY-MM-DD")}`,
                  });
                }}
              />
            </div>
          </div>

          <div className="flex flex-col px-5 mb-10">
            <ModelRentalStatistics />
          </div>

          <div className="flex flex-col gap-10">
            <CartRetentionChart
              selectedDuration={selectedDuration}
              {...props}
            />
            <RentalMasterRetentionChart
              selectedDuration={selectedDuration}
              {...props}
            />
            <RentalRetentionChart
              selectedDuration={selectedDuration}
              {...props}
            />
          </div>
        </div>
      </div>
    );
  }, [selectedDuration]);

  return render();
};

export default connect(
  mapStateToProps,
  mapDispatchProps
)(ModelActivityApprovedAtIndex);
